"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WindowMode;
(function (WindowMode) {
    WindowMode["POPUP"] = "POPUP";
    WindowMode["REDIRECT"] = "REDIRECT";
})(WindowMode = exports.WindowMode || (exports.WindowMode = {}));
//# sourceMappingURL=WindowMode.js.map